<template>
  <div class="about">
    <h1>This is an TEST page</h1>
  </div>
</template>

<script>
export default {};
</script>
